<template>
    <c-dialog ref="dialog" :title="detail.title" mode="slide" width="75vw" enable-flex :button="false">
      <div v-if="!isNotice && detail.category_name" class="article-meta">{{ detail.category_name }}</div>
      <div v-html="detail.content" class="agreement-content" />
    </c-dialog>
</template>

<script>
export default {
  name: 'articleDetail',
  props: {
    article_type: [Number, String],
    id: [Number, String]
  },
  data() {
    return { detail: {} };
  },
  computed: {
    isNotice() {
      return this.article_type === '1';
    }
  },
  methods: {
    open() {
      const id = this.id;
      const article_type = this.article_type;
      this.detail = {};
      this.request({
        url: "/article/published/detail",
        data: { id, article_type },
        loading: true,
        success: data => {
          if (this.id !== id || this.article_type !== article_type) return;
          this.detail = data || {};
          if (data && data.id && ['1', '2'].includes(article_type.toString())) {
            this.$nextTick(() => {
              if (this._isDestroyed || this.id !== id || this.article_type !== article_type) return;
              this.request({
                url: "/article/published/read",
                data: { id, article_type }
              });
            });
          }
          this.$refs.dialog.open();
        }
      });
    }
  }
};
</script>

<style scoped>
.article-meta {
  margin-bottom: 20px;
  color: #999;
  font-size: 13px;
}
.agreement-content {
  padding: 20px 32px;
  line-height: 28px;
  font-size: 14px;
}
</style>
